export interface ProgramStat {
  number: string;
  label: string;
}

export interface Program {
  id: string;
  title: string;
  category: string;
  description: string;
  image: string;
  features: string[];
  stats: ProgramStat[];
  isFutureInitiative?: boolean;
}

export const programs: Program[] = [
  {
    id: 'cndc',
    title: 'Community Nutritional Development Project (CNDC)',
    category: 'Nutrition & Support',
    description: 'Fighting hunger by providing nutritious meals and connecting beneficiaries with government services and skills training.',
    image: '/feeding.png',
    features: [
      'Daily nutritious meals for vulnerable community members',
      'Gateway to sustainable poverty alleviation',
      'Connection to government services',
      'Skills training opportunities',
      'Comprehensive support system'
    ],
    stats: [
      { number: '250+', label: 'Meals Daily' },
      { number: '300+', label: 'People Served Weekly' },
      { number: '15+', label: 'Years Running' }
    ]
  },
  {
    id: 'epwp',
    title: 'EPWP Program',
    category: 'Employment Initiative',
    description: 'Collaborating with the government to create work opportunities and reduce unemployment in Kayamandi.',
    image: '/support.png',
    features: [
      'Temporary to long-term work opportunities',
      'Government partnership',
      'Poverty reduction focus',
      'Skills development',
      'Community economic growth'
    ],
    stats: [
      { number: '100+', label: 'Jobs Created' },
      { number: '5+', label: 'Years Active' },
      { number: '24/7', label: 'Dedication' }
    ]
  },
  {
    id: 'gbv-advocacy',
    title: 'Advocacy against Gender-Based Violence',
    category: 'Support & Awareness',
    description: 'Supporting and advocating for the rights and safety of women and children affected by GBV.',
    image: '/crisis.png',
    features: [
      'Awareness campaigns',
      'Counseling services',
      'Survivor support',
      'Policy advocacy',
      'Community education'
    ],
    stats: [
      { number: '100%', label: 'Confidential' },
      { number: '50+', label: 'Cases Monthly' },
      { number: '10+', label: 'Awareness Events' }
    ]
  },
  {
    id: 'senior-programs',
    title: 'Senior Citizens Programs',
    category: 'Community Support',
    description: 'Supporting the well-being of senior citizens through comprehensive care and activities.',
    image: '/workshop.png',
    features: [
      'Social support networks',
      'Health and wellness activities',
      'Educational programs',
      'Community engagement',
      'Independence support'
    ],
    stats: [
      { number: '100+', label: 'Seniors Served' },
      { number: '12+', label: 'Monthly Activities' },
      { number: '5+', label: 'Support Areas' }
    ]
  },
  {
    id: 'alcohol-abuse-prevention',
    title: 'Alcohol Abuse Prevention',
    category: 'Health & Wellness',
    description: 'Comprehensive services to prevent and address alcohol abuse in the community.',
    image: '/support.png',
    features: [
      'Education programs',
      'Counseling services',
      'Support groups',
      'Community outreach',
      'Recovery support'
    ],
    stats: [
      { number: '200+', label: 'People Helped' },
      { number: '10+', label: 'Support Groups' },
      { number: '24/7', label: 'Crisis Support' }
    ]
  },
  {
    id: 'community-center',
    title: 'Kayamandi Community Center',
    category: 'Future Initiative',
    description: 'A dedicated venue for project initiatives and a safe space for women and children in the community.',
    image: '/Centre.png',
    features: [
      'Safe space for women and children',
      'Program venue',
      'Community hub',
      'Resource center',
      'Empowerment programs'
    ],
    stats: [
      { number: 'Coming', label: 'Soon' },
      { number: '1000+', label: 'Expected Beneficiaries' },
      { number: '10+', label: 'Programs Planned' }
    ],
    isFutureInitiative: true
  }
];
